import React, { useCallback, useState } from "react";
import useApiEp from "../../hooks/useApiEp";
import {
  Box,
  Card,
  CardContent,
  Chip,
  Container,
  Typography,
} from "@mui/material";
import TopTitleActions from "../../widgets/TopTitleActions";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";
import { useNavigate } from "react-router-dom";
import DataTable from "../../widgets/DataTable";
import CustomCircularP from "../../widgets/CustomCircularP";
import SimpleYesNoDialog from "../../widgets/SimpleYesNoDialog";
import axios from "axios";
import { getHeader, toastError } from "../../utils/util";
import { toast } from "react-toastify";
import { API_ENDPOINT } from "../../utils/constants";

const ChatbotList = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [showDelete, setShowDelete] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [toDelete, setToDelete] = useState("");
  const { data, isLoading, isError, refetch } = useApiEp(
    `/message/get-responses?page=${page}`
  );
  const handleAddBot = () => {
    navigate(`/home/add-response`);
  };
  const handleAction = useCallback((action, id) => {
    switch (action) {
      case "view":
        navigate(`/home/${id}/chatbot-detail`);
        break;
      case "edit":
        navigate(`/home/${id}/edit-chatbot`);
        break;
      case "delete":
        setToDelete(id);
        setShowDelete(true);
        break;
      default:
        console.warn("unknown action", id);
    }
  }, []);
  return (
    <Container sx={{ mt: 3 }}>
      <TopTitleActions
        title="Chatbot List"
        actions={[
          {
            icon: <SmartToyOutlinedIcon />,
            label: "Add Bot",
            action: handleAddBot,
          },
        ]}
      />
      <CustomCircularP show={deleting} />
      <SimpleYesNoDialog
        show={showDelete}
        setShow={setShowDelete}
        title={"Please confirm!"}
        message={"Are you sure you want to delete this item?"}
        onYes={async () => {
          try {
            setDeleting(true);
            setShowDelete(false);
            const response = await axios.delete(
              `${API_ENDPOINT}/message/delete-chatbot-message/${toDelete}`,
              getHeader()
            );
            toast.success(response.data.message);
            refetch();
          } catch (error) {
            toastError(error);
          } finally {
            setDeleting(false);
          }
        }}
      />
      <DataTable
        sx={{ mb: 1 }}
        columns={[
          {
            id: "serial",
            label: "S.No.",
            render: (_v, _row, idx) => (page - 1) * limit + idx + 1,
          },
          { id: "type", label: "Type" },
          {
            id: "triggerText",
            label: "Trigger Text",
            render: (v) => (
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                {v.map((item, index) => (
                  <Chip
                    clickable
                    key={index}
                    label={item}
                    size="small"
                    variant="outlined"
                  />
                ))}
              </Box>
            ),
          },
          {
            id: "createdOn",
            label: "Created On",
            render: (v) =>
              new Date(v).toLocaleString("en-IN", {
                dateStyle: "medium",
              }),
          },
        ]}
        actions={["view", "delete", "edit"]}
        rows={data?.data ?? []}
        page={page}
        limit={limit}
        totalPages={data?.totalPages ?? 1}
        onPageChange={setPage}
        onAction={handleAction}
      />
    </Container>
  );
};

export default ChatbotList;
